<template>
  <div class="activity-box">
    <div class="main">
      <img class="bg" src="./images/bg.png" alt="" />
      <div class="dressup1">
        <img
          src="https://resource.3uplay.com/sys-feed/2a44a801-a65f-4d41-a01f-bccbb74492da1633009653487158662.webp"
          alt=""
        />
      </div>
      <div class="dressup2">
        <span>一起看星空～</span>
        <img
          src="https://resource.3uplay.com/sys-feed/2dcd75c5-8d04-40a8-96b1-e45ff84aa5084665790714473859480.webp"
          alt=""
        />
      </div>
      <div class="score">{{ score ? score : '--' }}&nbsp;個</div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { reportPagelog as reportPagelogRequest } from '@/utils/report-page-log';
export default {
  name: 'ActivityBox',
  data() {
    return {
      score: 0
    };
  },
  computed: {
    ...mapGetters(['userInfo']),
    uuid() {
      return this.userInfo ? this.userInfo.uuid : '';
    }
  },
  watch: {},
  methods: {
    reportPagelog() {
      const { fullPath, query } = this.$route;
      const channel = query && query.pageFrom ? 0 : 1;
      reportPagelogRequest(fullPath, this.uuid, channel);
    },
    async getScore() {
      try {
        const url = `https://devops.nicee.app/api/huodong/xkzy/${this.uuid}`;
        const { data } = await this.$http.get(url);
        this.score = data.lndf;
      } catch (error) {
        console.log(error);
      }
    }
  },
  created() {
    this.reportPagelog();
    this.getScore();
  }
};
</script>
<style lang="scss" scoped>
.activity-box {
  width: 100%;
  background-color: #010119;
  background-image: url('./images/web-bg.png');
  background-size: 100% 100%;
  overflow: auto;
  text-align: center;
  font-size: 0;
  .main {
    position: relative;
    display: inline-block;
    width: 980px;
    text-align: left;
    > .bg {
      width: 100%;
    }
    .dressup1,
    .dressup2 {
      position: absolute;
      font-size: 0;
      top: 1200px;

      span {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 64px;
        color: #2e5e7f;
        z-index: 1;
      }
    }
    .dressup1 {
      left: 355px;
      img {
        width: 270px;
        height: auto;
      }
    }
    .dressup2 {
      left: 309px;
      top: 2383px;
      span {
        font-size: 30px;
        color: #2e5e7f;
        display: inline-block;
        text-align: center;
        width: 270px;
      }
      img {
        width: 350px;
        height: auto;
      }
    }
  }
  .score {
    position: absolute;
    top: 3744px;
    left: 574px;
    font-size: 32px;
    color: white;
  }
}
</style>
